/**
 * The Freshworks support chat, for clinicians only: it used to load on every screen from public/index.html, the
 * students' screens included. Header calls this once the signed-in user is known to be a therapist.
 */
let loaded = false

export function loadSupportWidget() {
    if (loaded || typeof document === 'undefined') {
        return
    }
    loaded = true
    window.fwSettings = { widget_id: 72000001703 }
    if (typeof window.FreshworksWidget !== 'function') {
        const queue = function () {
            queue.q.push(arguments)
        }
        queue.q = []
        window.FreshworksWidget = queue
    }
    // Its own green launcher stays hidden: Help in the header opens it (HelpPanel, Report a problem).
    window.FreshworksWidget('hide', 'launcher')
    const script = document.createElement('script')
    script.src = 'https://widget.freshworks.com/widgets/72000001703.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
}
